import React from 'react';

import { Box } from '@mui/material';
import cx from 'classnames';

import useStyles from './styles';

interface CardLabelsProps {
  wrapperClass?: string;
}

const CardLabels: React.FC<CardLabelsProps> = ({ wrapperClass, children }) => {
  const classes = useStyles();

  return <Box className={cx(classes.wrapper, wrapperClass)}>{children}</Box>;
};

export default CardLabels;
